/**
 * @biopeak/health — camada única e tipada sobre HealthKit e Health Connect.
 *
 * Consumo esperado pelo app:
 *
 *   const service = new HealthService({ plugin: Health, supabase, devicePlatform, consentTextVersion });
 *   await service.grantConsent('vitals');   // consentimento no app, primeiro
 *   await service.connect(['vitals']);      // e só então o prompt do SO
 *   await service.sync({ domains, since, trigger: 'foreground' });
 *
 * Chamar `Health.requestAuthorization()` direto pula o gate de consentimento.
 * Use sempre `HealthService.connect()`.
 */

import { registerPlugin } from '@capacitor/core';
import type { HealthPlugin } from './definitions.ts';

export const Health = registerPlugin<HealthPlugin>('Health', {
  web: () => import('./web.ts').then((m) => new m.HealthWeb()),
});

export * from './types.ts';
export * from './definitions.ts';
export { HealthService, ConsentRequiredError } from './service.ts';
export type { HealthServiceOptions } from './service.ts';

/**
 * Tradução dos slugs de atividade. Mora aqui, e não no app, porque os slugs
 * são PRODUZIDOS aqui (`HealthKitTypes.activityName()` no iOS,
 * `HealthConnectTypes.exerciseName()` no Android) — o vocabulário e sua
 * tradução pertencem ao mesmo pacote. Antes vivia só no app do paciente; o
 * painel do médico passou a precisar dela e duplicar significaria as duas
 * telas divergirem na primeira atividade nova que o SDK emitisse.
 */
export { activityLabel } from './activityLabels.ts';
